import React, { useState } from 'react';
import PaymentMethodPicker from './PaymentMethodPicker';

/** Every upgrade surface uses the same provider choice. */
function ProCheckoutButton({ user, children, className = '', whishOnly = false, disabled = false, onCheckout }) {
  const [open, setOpen] = useState(false);
  const [preparing, setPreparing] = useState(false);
  const [error, setError] = useState('');
  const begin = async () => {
    if (preparing) return;
    setError('');
    setPreparing(true);
    try { await onCheckout?.(); setOpen(true); }
    catch (failure) { setError(failure.message || 'Could not prepare checkout. Please try again.'); }
    finally { setPreparing(false); }
  };
  return (
    <>
      <button type="button" className={className} onClick={begin} disabled={!user || disabled || preparing} aria-busy={preparing}>
        {children}
      </button>
      {error && <p role="alert" className="js-checkout-preparation-error">{error}</p>}
      {open && <PaymentMethodPicker user={user} whishOnly={whishOnly} onClose={() => setOpen(false)} />}
    </>
  );
}
export default ProCheckoutButton;
